import { useEffect } from 'react';
import { useNotify } from '../Notify';
import { getApiErrorWithEntityName } from '@shared/api';

export function useErrorNotify(error: any, entityName?: string): void {
    const notify = useNotify();
    useEffect(() => {
        if (error) notify.error(getApiErrorWithEntityName(error, entityName));
    }, [error, entityName]);
}
